<template>
  <v-modal
    class="confirmation-modal"
    v-bind="$attrs"
    v-on="$listeners"
    :title="$t('confirmation')"
    :close-button="false"
  >
    <div class="confirmation-modal__message">
      <slot>
        {{ $t(message) }}
      </slot>
    </div>
    <template slot="footer">
      <button
        class="v-modal__close-button text-link"
        role="button"
        @click.prevent="handleCancel"
      >
        {{ $t('finishEditing') }}
      </button>
      <v-button
        :content="$t('discardChangesAndContinue')"
        @click="handleConfirm"
      />
    </template>
  </v-modal>
</template>

<script>
  export default {
    name: 'ConfirmationModal',
    props: {
      message: String,
      onConfirm: Function,
      onCancel: Function,
    },
    methods: {
      handleConfirm() {
        if (typeof this.onConfirm === 'function') {
          this.onConfirm();
        }
      },
      handleCancel() {
        if (typeof this.onCancel === 'function') {
          this.onCancel();
        }

        this.$emit('update:visible', false);
      },
    },
  };
</script>

<style lang="scss">
  .confirmation-modal {
    &__message {
      font-size: 18px;
      padding: 10px 0;
    }

    .v-modal__content {
      padding: 15px;
    }
  }
</style>
